import React, { useRef, useState } from 'react';
import SignatureCanvas from 'react-signature-canvas';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const SignaturePad = ({ onSave, onCancel, signerName }) => {
  const sigPadRef = useRef(null);
  const [isEmpty, setIsEmpty] = useState(true);

  const handleClear = () => {
    sigPadRef?.current?.clear();
    setIsEmpty(true);
  };

  const handleSave = () => {
    if (sigPadRef?.current?.isEmpty()) {
      alert('الرجاء التوقيع أولاً');
      return;
    }

    const signatureData = sigPadRef?.current?.toDataURL('image/png');
    onSave?.(signatureData);
  };

  const handleBegin = () => {
    setIsEmpty(false);
  };

  return (
    <div className="space-y-4">
      <div className="bg-muted/30 rounded-lg p-4">
        <div className="flex items-center justify-between mb-3">
          <div className="flex items-center gap-2">
            <Icon name="PenTool" size={20} color="#DAA520" />
            <h4 className="text-sm font-semibold text-foreground">
              {signerName ? `توقيع: ${signerName}` : 'التوقيع الإلكتروني'}
            </h4>
          </div>
          <Button
            variant="ghost"
            size="sm"
            onClick={handleClear}
            disabled={isEmpty}
          >
            <Icon name="RotateCcw" size={16} />
            <span className="mr-2">مسح</span>
          </Button>
        </div>

        <div className="bg-white rounded-lg border-2 border-dashed border-border overflow-hidden">
          <SignatureCanvas
            ref={sigPadRef}
            canvasProps={{
              className: 'signature-canvas',
              style: {
                width: '100%',
                height: '200px'
              }
            }}
            backgroundColor="#ffffff"
            penColor="#000000"
            onBegin={handleBegin}
          />
        </div>

        <p className="text-xs text-muted-foreground mt-2 text-center">
          استخدم الماوس أو شاشة اللمس للتوقيع في المربع أعلاه
        </p>
      </div>

      <div className="bg-blue-500/10 border border-blue-500/30 rounded-lg p-3">
        <div className="flex items-start gap-2">
          <Icon name="Shield" size={16} color="#3B82F6" />
          <div className="flex-1">
            <p className="text-xs text-foreground font-medium">التوقيع الإلكتروني الآمن</p>
            <p className="text-xs text-muted-foreground mt-1">
              سيتم تشفير توقيعك وحفظه بشكل آمن مع سجل تدقيق كامل يتضمن التاريخ والوقت وعنوان IP
            </p>
          </div>
        </div>
      </div>

      <div className="flex justify-end gap-3">
        <Button variant="outline" onClick={onCancel}>
          إلغاء
        </Button>
        <Button variant="default" onClick={handleSave} disabled={isEmpty}>
          <Icon name="Check" size={16} />
          <span className="mr-2">حفظ التوقيع</span>
        </Button>
      </div>
    </div>
  );
};

export default SignaturePad;